import { Component } from '@angular/core';

@Component({
  selector: 'app-create-profile-main',
  templateUrl: './create-profile-main.component.html',
  styleUrls: ['./create-profile-main.component.css']
})
export class CreateProfileMainComponent {
  english:boolean=true;
  hindi:boolean=false;
  ngOnInit(): void {
    const storeVal = localStorage.getItem('selectedValue');
    if (storeVal == 'english') {
      this.english = true;
      this.hindi = false;
    }
    if (storeVal == 'hindi') {

      this.english = false;
      this.hindi = true;
    }

  }
}
